import firestoreSecurityRules from "refractor/firestore-security-rules";
export default firestoreSecurityRules;